import { createGetAllAPI, createPatchAPI, createPostAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

import { BASE_URL } from '../constants/api';

const {
  useGetAll: useMappingLogsGetAll,
  invalidate: invalidateMappingLogs,
} = createGetAllAPI({
  getURL: query => {
    return `${BASE_URL}/demo/mapping-logs/?${stringify(query)}`;
  },
});

const { usePatch: useMappingLogPatch } = createPatchAPI({
  getURL: mappingLogId => `${BASE_URL}/demo/mapping-log/${mappingLogId}`,
});

const { usePost: useAutoMappingPost } = createPostAPI({
  getURL: _ => `${BASE_URL}/demo/mapping-logs/`,
});

export {
  useMappingLogsGetAll,
  invalidateMappingLogs,
  useMappingLogPatch,
  useAutoMappingPost,
};
